export const gitCommit = 'b061878b'
